import { Button, Flex, Heading, Icon, Text } from "@chakra-ui/react";
import { FiPlusCircle } from "react-icons/fi";
import { useTranslation } from "react-i18next";
import { useCreateNeed } from "./useCreateNeed";

export const NewNeed = () => {
  const { t } = useTranslation();
  const { create, isCreating } = useCreateNeed();

  return (
    <Flex direction="column" align="center" justify="center" gap="4" py="20" textAlign="center">
      <Icon as={FiPlusCircle} boxSize="32px" color="smPrimary" />
      <Heading as="h1" size="lg" color="smText">
        {t("Report a need")}
      </Heading>
      <Text color="smMuted" maxW="md">
        {t("Register a new procurement need.")}
      </Text>
      <Button colorScheme="teal" onClick={create} isLoading={isCreating}>
        {t("Report a need")}
      </Button>
    </Flex>
  );
};
